import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    paddingTop: "20px",
    minHeight: "calc(100vh - 191px)",
    display: "flex",
    flexDirection: "column"
  },
  appearanceContainer:{
    display: "flex",
    flex: 1,
    height: "100%",
  },
  configurationContainer: {
    flex: 1,
    minHeight: "calc(100vh - 360px)",
    maxWidth: "550px",
  },

  //tab
  tabsWrapper: {
    marginLeft: "16px",
    "& .MuiTabs-root": {
      height: "35px",
      "& .MuiTabs-scroller": {
        "& .MuiTabs-indicator": {
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
  },
  tab: {
    textTransform: "none",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "14px",
    marginRight: "16px",
    padding: "0 !important",
  },

  //AppearanceItem
  appearanceItem: {
    margin: "24px"
  },
  appearanceItemTitle: {
    color: "#373534",
    fontSize: "16px",
    fontWeight: 600,
  },
  appearanceItemNotice: {
    color: "#7E7E8F",
    fontSize: "12px",
    fontWeight: 400,
  },
  appearanceItemRadioGroup: {
    marginTop: "16px"
  },
  separator: {
    borderTop: "1px #F2F3F7",
    margin: "20px"
  },

  //Inputs
  inputWrapper: {
    display: "flex",
    marginBottom: "16px",
  },
  paletteContainer: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap"
  },
  selectedPalette: {
    border: "2px solid black",
    padding: "2px",
    borderRadius: "12px",
  },
  unselectedPalette: {
    border: "2px solid transparent",
    padding: "2px"
  },
  inputPaletteItemWrapper: {
    height: "40px",
    width: "123px",
    borderRadius: "12px",
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
  },
  inputPaletteItemColorPart: {
    flex: 1,
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  inputItemLabelWrapper: {
    flex: 1
  },
  inputItemInputWrapper: {
    flex: 1,
  },
  inputItemInputWrapperLogo: {
    backgroundColor: "#F2F3F7",
    height: "51px",
    width: "129px",
    borderRadius: "8px",
    marginRight: "28px",
    position: "relative",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  camaraIcon: {
    position: "absolute",
    bottom: "-8px",
    right: "-8px",
  },
  inputItemTitle: {
    color: "#7E7E8F",
    fontSize: "12px",
    fontWeight: 600,
  },
  inputItemLogoTitle: {
    color: "#373534",
    fontSize: "12px",
    fontWeight: 600,
  },
  inputItemNotice: {
    color: "#7E7E8F",
    fontSize: "12px",
    fontWeight: 400,
  },
  inputItemLogoNotice: {
    color: "#373534",
    fontSize: "12px",
    fontWeight: 400,
  },
  inputItemRemoveImage: {
    color: "#FF0001",
    fontSize: "12px",
    fontWeight: 400,
    textDecoration: "underline",
    cursor: "pointer"
  },
  inputItemColorWrapper: {
    border: "1px solid",
    height: "40px",
    borderRadius: "46px",
    cursor: "pointer",
    position: 'relative',
    display: "flex",
    alignItems: "center",
  },
  inputItemColor: {
    border: "none",
    padding: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "transparent",
    cursor: "pointer",
    display: 'none',
    zIndex: 10
  },
  colorPlaceholderContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  colorPlaceholder: {
    color: "#535362",
    fontSize: "14px",
    fontWeight: 600
  },
  colorInputColorPart: {
    width: '40px',
    height: '38px',
    borderRadius: '16px 0 0 16px',
  },
  pickerContainer: {
    position: 'absolute',
    top: '40px',
    zIndex: 1,
  },

  // Preview
  previewWrapper:{
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  previewContainer: {
    backgroundColor: "#f2f3f7",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "628px",
    height: "533px",
  },
  previewContent: {
    borderRadius: "6px",
    width: "500px",
    height: "377px",
    margin: "20px 20px 20px 20px",
    backgroundColor: "white",
    filter: "drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.07))"
  },
  previewContentHeader: {
    backgroundColor: "#FFFFFF",
    height: "52px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  previewContentNavigationLogo: {
    marginLeft: "16px",
    fontSize: "12px",
  },
  previewContentHeaderAvatar: {
    width: "19px",
    height: "19px",
    borderRadius: "4px",
    marginRight: "16px",
  },
  previewContentMainWreapper: {
    display: "flex",
    height: "calc(100% - 52px)",
  },
  previewContentNavigation: {
    backgroundColor: "#FFFFFF",
    width: "94px",
  },
  previewContentNavigationItemsWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    paddingLeft: "22px",
    paddingTop: "17px"
  },
  previewContentNavigationItemDark: {
    height: "7px",
    width: "12px",
    backgroundColor: "#7E7E8F",
    borderRadius: "4px",
  },
  previewContentNavigationItemLight: {
    height: "7px",
    width: "45px",
    backgroundColor: "#C6CBD9",
    borderRadius: "4px",
  },
  previewContentMain: {
    backgroundColor: "#E2E2EA",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  previewContentMainCardsWrapper: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "33px",
    padding: "0 11px 0 11px"
  },
  previewContentMainCardItem: {
    width: "119px",
    height: "165px",
    backgroundColor: "white",
    borderRadius: "4px",
  },
  previewContentMainFooterWrapper: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0 16px 10px 16px",
    alignItems: "center",
  },
  previewContentMainFooterBar: {
    width: "90px",
    height: "6px",
    backgroundColor: "#C6CBD9",
  },
  previewContentMainFooterBtn: {
    width: "58px",
    height: "19px",
    borderRadius: "4px",
  },
}));

export default useStyles;
